import React, { useState, useEffect } from 'react'
import ProgressBar from './ProgressBar'
import axios from 'axios'

const ExamPaper = () => {
    const [state, setState] = useState({
        subject:'', subjectFile:null
    })    
    const [data, setData] = useState([])
    const [upload, setUpload] = useState(false)
    const [uploadpercents, setUploadPercents] = useState(0)
    const [uploadError, setUploadError] = useState(null)
    const [message, setMessage] = useState('')
    const { subject, subjectFile} = state

    const fetchData = async () => {
        try {
            const ACTION_URL = `https://www.durgacollege.in/dashboard/backend/fetch_question_paper.php`;
            const res = await fetch(ACTION_URL, {method:'GET'})
            const data = await res.json()
            if (res.status === 200 && data) {
                setData(data)
            }
        } catch (error){
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData()
        document.title = 'Exam Paper | Durga College Admin panel'
    }, [])

    const submitEvent = async (e) => {
        e.preventDefault()  
        if (subject && subjectFile) {
            try {
                setUpload(true)
                const fd = new FormData(e.target)
                fd.append('action', 'examPaper')
                const res = await axios.post('https://www.durgacollege.in/dashboard/backend/action.php', fd, {
                    onUploadProgress: progressEvent => {
                        const { loaded, total } = progressEvent
                        let percent = Math.round( (loaded * 100 ) / total)
                        setUploadPercents(percent)                   
                    }
                })
                if (res.status === 200 && res.data.status){
                    setMessage(<div className="mb-3 success-message">{res.data.message}</div>)
                    setState({subject:'', subjectFile:null})
                    fetchData()
                    setTimeout(() => {
                        setUploadPercents(0)    
                    }, 2000)
                } else {
                    setUploadError('#a02b31')
                    setMessage(<div className="mb-3 error-message">{res.data.message}</div>)
                }
                setUpload(false)
            } catch (error) {
                
            }
        }
    }

    const deletePaper = async id => {        
        try {
            const ACTION_URL = `https://www.durgacollege.in/dashboard/backend/delete_question_paper.php?id=${id}`;
            const res = await fetch(ACTION_URL, {method:'GET'})
            const json = await res.json()
            if (res.status === 200 && json) {
                const filterData = data.filter(item => {
                    return item.id !== id
                })                
                setData(filterData)     
                // console.log(data);           
            }
        } catch (error){
            console.log(error);
        }        
    }

    return (
        <div className="card shadow">
        { 
            uploadpercents ? <ProgressBar uploadpercents={uploadpercents} uploadError={uploadError} /> : null
        }
            <div className="card-body">
                <h3 className="card-title">Add Question Paper</h3>
                <br/>
                <div id="message">{message}</div>

                <form onSubmit={submitEvent} method="post" autoComplete="off" encType="multipart/form-data">
                    <div className="mb-3">
                        <label htmlFor="subject" className="form-label">Subject : *</label>
                        <input
                            type="type"
                            name="subject"
                            className="form-control"
                            onChange={e => setState({...state, subject:e.target.value})} 
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="subjectFile" className="form-label">Choose File : *</label>
                        <input
                            type="file"
                            name="subjectFile"
                            className="form-control"
                            accept=".pdf"
                            onChange={e => setState({...state, subjectFile:e.target.files[0]})} 
                        />
                        <small id="emailHelp" className="form-text text-muted">Please select pdf File Only.</small>
                    </div>                    
                    <button type="submit" className="btn btn-primary">
                    {
                        !upload ? 'Upload' : 'Uploading...'
                    }</button>
                </form>
            </div>
            
            <div className="card-body">
                <h3 className="card-title mb-3">View All</h3>
                <div className="table-responsive">
                    <table className="table table-sm table-bordered">
                    <thead className="table-dark">
                        <tr>
                            <th width="5%">Sr</th>
                            <th width="10%">Date</th>
                            <th>Subject</th>
                            <th width="10%">File</th>
                            <th width="10%" className="text-center">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        !data.length ? <tr><td colSpan="5">No Data found</td></tr> : 
                        data.map((ele, idx) => {
                            return <tr key={idx}>
                                <td>{idx+1}</td>
                                <td>{ele.insdate}</td>
                                <td>{ele.subject_name}</td>
                                <td className="text-center">
                                    <a href={`https://www.durgacollege.in/images/exam/${ele.file}`} target="_blank" rel="noreferrer">View</a>
                                </td>
                                <td className="text-center">
                                    <button 
                                        type="botton" 
                                        className="btn btn-danger btn-sm" 
                                        onClick={() => {
                                            if (window.confirm('Are you sure you want to delete this?')) {
                                                deletePaper(ele.id)
                                            }
                                        }}>Delete</button>
                                </td>
                            </tr>
                        })
                    } 
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    )
}

export default ExamPaper
